// Light / dark mode for the PMS. A persisted flag flips a `data-pm-mode` attribute
// on <html>; index.css defines light tokens on :root and dark overrides on
// :root[data-pm-mode="dark"], so every var(--pm-*) surface re-themes with no
// component changes. The CMS brand bridge (useBrand) still wins for any key it
// sets (Settings -> Colors -> AUX Projects; now empty so these defaults govern).
const KEY = 'pm_mode';

export function getMode() {
  try {
    return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light';
  } catch {
    return 'light';
  }
}

export function applyMode(mode) {
  const m = mode === 'dark' ? 'dark' : 'light';
  document.documentElement.setAttribute('data-pm-mode', m);
}

export function toggleMode() {
  const next = getMode() === 'dark' ? 'light' : 'dark';
  try {
    localStorage.setItem(KEY, next);
  } catch {
    /* ignore quota/privacy errors */
  }
  applyMode(next);
  return next;
}

// Instant paint on load, before React mounts, so there is no light→dark flash.
applyMode(getMode());
